// assets/customize-modal.js
(function () {
  function openModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    const firstFocusable = modal.querySelector('input,select,textarea,button,[href]');
    firstFocusable && firstFocusable.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  document.addEventListener('click', (e) => {
    // Open
    const openBtn = e.target.closest('[data-open-customizer]');
    if (openBtn) {
      e.preventDefault();
      openModal(openBtn.getAttribute('data-open-customizer'));
      return;
    }
    // Close via backdrop or X or Cancel
    if (e.target.matches('[data-close]')) {
      const modal = e.target.closest('.customize-modal');
      closeModal(modal);
      return;
    }
    // Apply: keep inputs in the form, just close the modal
    if (e.target.matches('[data-apply]')) {
      const modal = e.target.closest('.customize-modal');
      // Optionally add lightweight validation here if some fields are required
      closeModal(modal);
      return;
    }
  });

  // ESC to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const open = document.querySelector('.customize-modal.is-open');
      if (open) closeModal(open);
    }
  });
})();